import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[inputFocus]'
})
export class InputFocusDirective implements OnChanges {
  @Input() public inputFocus:boolean;

  constructor(
    private element:ElementRef
  ) {
    /**/
  }

  public ngOnChanges(changes:SimpleChanges):void {
    if (changes.inputFocus?.currentValue) {
      const input:HTMLInputElement = this.element.nativeElement;

      // set focus to element
      input.focus();
    }
  }
}